import { useContext } from 'react'
import { useQuery, useMutation, useQueryClient } from 'react-query'
import { apiGet, apiDelete } from 'api'
import { baseUrl } from 'api/helpers'
import AuthContext from 'context/auth-context'
import axios from 'axios'

const getAnalyticPolicyRules = async (token, analyticId) => {
  const url = `analytics/${analyticId}/policy_rules`
  const data = await apiGet({ url, token })
  return data
}

export const useAnalyticPolicyRules = ({ analyticId, options = {} } = {}) => {
  const token = useContext(AuthContext)

  const queryFn = () => getAnalyticPolicyRules(token, analyticId)
  const queryKey = ['analytic-policy-rules', analyticId]

  return useQuery(queryKey, queryFn, {
    enabled: !!analyticId,
    ...options
  })
}

const linkPolicyRule = async (token, analyticId, policyRuleId) => {
  const url = `${baseUrl}/analytics/${analyticId}/policy_rules`
  const response = await axios.post(url, { policy_rule_id: policyRuleId }, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
  return response.data
}

export const useLinkPolicyRule = ({ analyticId, options = {} } = {}) => {
  const token = useContext(AuthContext)
  const queryClient = useQueryClient()

  return useMutation(
    (policyRuleId) => linkPolicyRule(token, analyticId, policyRuleId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['analytic-policy-rules', analyticId])
      },
      ...options
    }
  )
}

const unlinkPolicyRule = async (token, linkId) => {
  const url = `policy_rules/${linkId}`
  return apiDelete({ url, token })
}

export const useUnlinkPolicyRule = ({ analyticId, options = {} } = {}) => {
  const token = useContext(AuthContext)
  const queryClient = useQueryClient()

  return useMutation(
    (linkId) => unlinkPolicyRule(token, linkId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['analytic-policy-rules', analyticId])
      },
      ...options
    }
  )
}
